import { SVGProps } from 'react';
const SvgArrowUpRightLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 19 19 5M11 5h8v8"
    />
  </svg>
);
export default SvgArrowUpRightLg;
